var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveBloodSugar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7874 5.62891C17.7809 5.6222 17.7743 5.61556 17.7676 5.6091L12.3838 0.225333C12.0868 -0.0699026 11.6071 -0.0699026 11.3101 0.225333L3.77129 7.76417C3.64603 7.88871 3.56797 8.05291 3.55044 8.22867L3.00977 11.9981L6.05575 15.0441L9.82516 14.5034C9.98918 14.4814 10.1415 14.4065 10.2592 14.2902L17.7676 6.70566C18.0704 6.41382 18.0793 5.93175 17.7874 5.62891ZM7.00003 12.0362L5.91871 10.9929L6.99243 9.9192L8.06614 10.9929L7.00003 12.0362ZM8.61442 10.4218L7.5407 9.34807L8.61442 8.27436L9.68813 9.34807L8.61442 10.4218ZM13.9982 7.23109V7.19301L11.8432 9.34804C11.5461 9.64327 11.0665 9.64327 10.7694 9.34804L8.61442 7.23106C8.31918 6.93404 8.31918 6.45437 8.61442 6.15735L10.7694 4.00232C11.0665 3.70708 11.5461 3.70708 11.8432 4.00232L13.9982 6.15735C14.2935 6.4544 14.2935 6.93407 13.9982 7.23109Z",
    fill: "#3A2CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60815 13.148C1.31291 13.4451 1.31291 13.9247 1.60815 14.2217L3.76317 16.3768C4.06019 16.672 4.53987 16.672 4.83689 16.3768L5.59837 15.6153L2.38484 12.3789L1.60815 13.148Z",
    fill: "#3A2CA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000747106 16.9192L1.07617 17.9961L2.63233 16.44L1.55541 15.363L-0.000747106 16.9192Z",
    fill: "#3A2CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBloodSugar);
export default __webpack_public_path__ + "static/media/active-blood-sugar.86836bd5a7bdf01c5b13d4ad670e9011.svg";
export { ForwardRef as ReactComponent };